export const initAnimalFlowReport = (...args: Parameters<typeof import("./animalFlowReport").initAnimalFlowReport>) =>
    import("./animalFlowReport").then((module) => module.initAnimalFlowReport(...args));

export const initAnimalList = (...args: Parameters<typeof import("./animalList").initAnimalList>) =>
    import("./animalList").then((module) => module.initAnimalList(...args));

export const initAnimalLicenseReport = (
    ...args: Parameters<typeof import("./animalLicenseReport").initAnimalLicenseReport>
) => import("./animalLicenseReport").then((module) => module.initAnimalLicenseReport(...args));

export const initAnimalMovementReport = (
    ...args: Parameters<typeof import("./animalMovementReport").initAnimalMovementReport>
) => import("./animalMovementReport").then((module) => module.initAnimalMovementReport(...args));

export const initAnnouncementList = (...args: Parameters<typeof import("./announcementList").initAnnouncementList>) =>
    import("./announcementList").then((module) => module.initAnnouncementList(...args));

export const initApiClientList = (...args: Parameters<typeof import("./apiClientList").initApiClientList>) =>
    import("./apiClientList").then((module) => module.initApiClientList(...args));

export const initBirthReportList = (...args: Parameters<typeof import("./birthReportList").initBirthReportList>) =>
    import("./birthReportList").then((module) => module.initBirthReportList(...args));

export const initDrugApplicationReportList = (
    ...args: Parameters<typeof import("./drugApplicationReportList").initDrugApplicationReportList>
) => import("./drugApplicationReportList").then((module) => module.initDrugApplicationReportList(...args));

export const initDrugInventoryReportList = (
    ...args: Parameters<typeof import("./drugInventoryReportList").initDrugInventoryReportList>
) => import("./drugInventoryReportList").then((module) => module.initDrugInventoryReportList(...args));

export const initBreedingPerformanceReportList = (
    ...args: Parameters<typeof import("./breedingPerformanceReportList").initBreedingPerformanceReportList>
) => import("./breedingPerformanceReportList").then((module) => module.initBreedingPerformanceReportList(...args));

export const initBudgetingReport = (...args: Parameters<typeof import("./budgetingReport").initBudgetingReport>) =>
    import("./budgetingReport").then((module) => module.initBudgetingReport(...args));

export const initCageList = (...args: Parameters<typeof import("./cageList").initCageList>) =>
    import("./cageList").then((module) => module.initCageList(...args));

export const initCageFlowReport = (...args: Parameters<typeof import("./cageFlowReport").initCageFlowReport>) =>
    import("./cageFlowReport").then((module) => module.initCageFlowReport(...args));

export const initCommentList = (...args: Parameters<typeof import("./commentList").initCommentList>) =>
    import("./commentList").then((module) => module.initCommentList(...args));

export const initCryotankList = (...args: Parameters<typeof import("./cryotankList").initCryotankList>) =>
    import("./cryotankList").then((module) => module.initCryotankList(...args));

export const initDocumentList = (...args: Parameters<typeof import("./documentList").initDocumentList>) =>
    import("./documentList").then((module) => module.initDocumentList(...args));

export const initDeviceList = (...args: Parameters<typeof import("./deviceList").initDeviceList>) =>
    import("./deviceList").then((module) => module.initDeviceList(...args));

export const initDeviceEventList = (...args: Parameters<typeof import("./deviceEventList").initDeviceEventList>) =>
    import("./deviceEventList").then((module) => module.initDeviceEventList(...args));

export const initDrugList = (...args: Parameters<typeof import("./drugList").initDrugList>) =>
    import("./drugList").then((module) => module.initDrugList(...args));

export const initDrugPackageList = (...args: Parameters<typeof import("./drugPackageList").initDrugPackageList>) =>
    import("./drugPackageList").then((module) => module.initDrugPackageList(...args));

export const initDrugRegisterList = (...args: Parameters<typeof import("./drugRegisterList").initDrugRegisterList>) =>
    import("./drugRegisterList").then((module) => module.initDrugRegisterList(...args));

export const initDrugRequestList = (...args: Parameters<typeof import("./drugRequestList").initDrugRequestList>) =>
    import("./drugRequestList").then((module) => module.initDrugRequestList(...args));

export const initEmbryoList = (...args: Parameters<typeof import("./embryoList").initEmbryoList>) =>
    import("./embryoList").then((module) => module.initEmbryoList(...args));

export const initExportReportList = (...args: Parameters<typeof import("./exportReportList").initExportReportList>) =>
    import("./exportReportList").then((module) => module.initExportReportList(...args));

export const initHealthReportList = (...args: Parameters<typeof import("./healthReportList").initHealthReportList>) =>
    import("./healthReportList").then((module) => module.initHealthReportList(...args));

export const initInvoiceList = (...args: Parameters<typeof import("./invoiceList").initInvoiceList>) =>
    import("./invoiceList").then((module) => module.initInvoiceList(...args));

export const initInvoiceBatchList = (...args: Parameters<typeof import("./invoiceBatchList").initInvoiceBatchList>) =>
    import("./invoiceBatchList").then((module) => module.initInvoiceBatchList(...args));

export const initInvoicePreviewList = (
    ...args: Parameters<typeof import("./invoicePreviewList").initInvoicePreviewList>
) => import("./invoicePreviewList").then((module) => module.initInvoicePreviewList(...args));

export const initInfertilityReportList = (
    ...args: Parameters<typeof import("./infertilityReportList").initInfertilityReportList>
) => import("./infertilityReportList").then((module) => module.initInfertilityReportList(...args));

export const initLicenseList = (...args: Parameters<typeof import("./licenseList").initLicenseList>) =>
    import("./licenseList").then((module) => module.initLicenseList(...args));

export const initLocationList = (...args: Parameters<typeof import("./locationList").initLocationList>) =>
    import("./locationList").then((module) => module.initLocationList(...args));

export const initMutationList = (...args: Parameters<typeof import("./mutationList").initMutationList>) =>
    import("./mutationList").then((module) => module.initMutationList(...args));

export const initOrderRequestList = (...args: Parameters<typeof import("./orderRequestList").initOrderRequestList>) =>
    import("./orderRequestList").then((module) => module.initOrderRequestList(...args));

export const initOriginList = (...args: Parameters<typeof import("./originList").initOriginList>) =>
    import("./originList").then((module) => module.initOriginList(...args));

export const initOverpopulationReportList = (
    ...args: Parameters<typeof import("./overpopulationReportList").initOverpopulationReportList>
) => import("./overpopulationReportList").then((module) => module.initOverpopulationReportList(...args));

export const initProjectList = (...args: Parameters<typeof import("./projectList").initProjectList>) =>
    import("./projectList").then((module) => module.initProjectList(...args));

export const initSacrificeReportList = (
    ...args: Parameters<typeof import("./sacrificeReportList").initSacrificeReportList>
) => import("./sacrificeReportList").then((module) => module.initSacrificeReportList(...args));

export const initServiceList = (...args: Parameters<typeof import("./serviceList").initServiceList>) =>
    import("./serviceList").then((module) => module.initServiceList(...args));

export const initServiceRequestList = (
    ...args: Parameters<typeof import("./serviceRequestList").initServiceRequestList>
) => import("./serviceRequestList").then((module) => module.initServiceRequestList(...args));

export const initScheduledReportRuns = (
    ...args: Parameters<typeof import("./scheduledReportRuns").initScheduledReportRuns>
) => import("./scheduledReportRuns").then((module) => module.initScheduledReportRuns(...args));

export const initScheduledReportsList = (
    ...args: Parameters<typeof import("./scheduledReportsList").initScheduledReportsList>
) => import("./scheduledReportsList").then((module) => module.initScheduledReportsList(...args));

export const initSeverityAssessmentReportList = (
    ...args: Parameters<typeof import("./severityAssessmentReportList").initSeverityAssessmentReportList>
) => import("./severityAssessmentReportList").then((module) => module.initSeverityAssessmentReportList(...args));

export const initSeverityAssessmentResultsList = (
    ...args: Parameters<typeof import("./severityAssessmentResultsList").initSeverityAssessmentResultsList>
) => import("./severityAssessmentResultsList").then((module) => module.initSeverityAssessmentResultsList(...args));

export const initSeverityLevelList = (
    ...args: Parameters<typeof import("./severityLevelList").initSeverityLevelList>
) => import("./severityLevelList").then((module) => module.initSeverityLevelList(...args));

export const initSpermList = (...args: Parameters<typeof import("./spermList").initSpermList>) =>
    import("./spermList").then((module) => module.initSpermList(...args));

export const initStrainList = (...args: Parameters<typeof import("./strainList").initStrainList>) =>
    import("./strainList").then((module) => module.initStrainList(...args));

export const initSpeciesList = (...args: Parameters<typeof import("./speciesList").initSpeciesList>) =>
    import("./speciesList").then((module) => module.initSpeciesList(...args));

export const initTankLicenseReport = (
    ...args: Parameters<typeof import("./tankLicenseReport").initTankLicenseReport>
) => import("./tankLicenseReport").then((module) => module.initTankLicenseReport(...args));

export const initTankList = (...args: Parameters<typeof import("./tankList").initTankList>) =>
    import("./tankList").then((module) => module.initTankList(...args));

export const initTankCrossingList = (...args: Parameters<typeof import("./tankCrossingList").initTankCrossingList>) =>
    import("./tankCrossingList").then((module) => module.initTankCrossingList(...args));

export const initTankKillingReportList = (
    ...args: Parameters<typeof import("./tankKillingReportList").initTankKillingReportList>
) => import("./tankKillingReportList").then((module) => module.initTankKillingReportList(...args));

export const initTankLocationList = (...args: Parameters<typeof import("./tankLocationList").initTankLocationList>) =>
    import("./tankLocationList").then((module) => module.initTankLocationList(...args));

export const initTankReleaseReportList = (
    ...args: Parameters<typeof import("./tankReleaseReportList").initTankReleaseReportList>
) => import("./tankReleaseReportList").then((module) => module.initTankReleaseReportList(...args));

export const initTankStrainList = (...args: Parameters<typeof import("./tankStrainList").initTankStrainList>) =>
    import("./tankStrainList").then((module) => module.initTankStrainList(...args));

export const initCompetenceList = (...args: Parameters<typeof import("./competenceList").initCompetenceList>) =>
    import("./competenceList").then((module) => module.initCompetenceList(...args));

export const initTransgenicTransferList = (
    ...args: Parameters<typeof import("./transgenicTransferList").initTransgenicTransferList>
) => import("./transgenicTransferList").then((module) => module.initTransgenicTransferList(...args));

export const initUnboundAnimalList = (
    ...args: Parameters<typeof import("./unboundAnimalList").initUnboundAnimalList>
) => import("./unboundAnimalList").then((module) => module.initUnboundAnimalList(...args));

export const initUserCertificateList = (
    ...args: Parameters<typeof import("./userCertificateList").initUserCertificateList>
) => import("./userCertificateList").then((module) => module.initUserCertificateList(...args));

export const initUserList = (...args: Parameters<typeof import("./userList").initUserList>) =>
    import("./userList").then((module) => module.initUserList(...args));

export const initWeanReportList = (...args: Parameters<typeof import("./weanReportList").initWeanReportList>) =>
    import("./weanReportList").then((module) => module.initWeanReportList(...args));

export const initWellplateList = (...args: Parameters<typeof import("./wellplateList").initWellplateList>) =>
    import("./wellplateList").then((module) => module.initWellplateList(...args));

export const initWorkRequestClassList = (
    ...args: Parameters<typeof import("./workRequestClassList").initWorkRequestClassList>
) => import("./workRequestClassList").then((module) => module.initWorkRequestClassList(...args));

export const initWorkRequestList = (...args: Parameters<typeof import("./workRequestList").initWorkRequestList>) =>
    import("./workRequestList").then((module) => module.initWorkRequestList(...args));

export const initStrainMutationsReport = (
    ...args: Parameters<typeof import("./strainMutationsReport").initStrainMutationsReport>
) => import("./strainMutationsReport").then((module) => module.initStrainMutationsReport(...args));
